import React from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/react'

import App from './App'
import * as serviceWorker from './serviceWorker'
import { initSentry } from './sentry'

import './css/global.scss'
import 'react-toastify/dist/ReactToastify.css'
import 'react-confirm-alert/src/react-confirm-alert.css'

initSentry()

ReactDOM.render(
  <React.StrictMode>
    {process.env.NODE_ENV !== 'development' && (
      <script
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html: `(function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "mg0lpkdjx3");`,
        }}
      />
    )}
    <Sentry.ErrorBoundary
      fallback={
        <div role="alert">Something went wrong. Please refresh the page.</div>
      }
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
)

serviceWorker.unregister()
